<span [innerHTML]="'NOTIFICATION_TEMPLATES.NORM_ADHOC'|translate:notification"></span>
